import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { DOMNode, mergeAttributes, Node } from '@tiptap/core';
import { DOMParser, Fragment } from '@tiptap/pm/model';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { SimpleCalloutComponent } from './simple-callout.component';
import { DEFAULT_SIMPLE_CALLOUT_PROPS } from './simple-callout.model';

export const SIMPLE_CALLOUT_NODE_NAME = 'simpleCallout';
const simpleCalloutClassName = 'simple-callout';

export const SimpleCalloutExtension = (injector: Injector) => {
  return Node.create({
    name: SIMPLE_CALLOUT_NODE_NAME,
    content: 'block+',
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        title: {
          default: DEFAULT_SIMPLE_CALLOUT_PROPS.title,
        },
        color: {
          default: DEFAULT_SIMPLE_CALLOUT_PROPS.color,
        },
        icon: {
          default: DEFAULT_SIMPLE_CALLOUT_PROPS.icon,
        },
        custom_css: {
          default: '',
        },
        custom_style: {
          default: null,
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== simpleCalloutClassName);
            return { class: `${simpleCalloutClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${simpleCalloutClassName}`,
          getContent(node: DOMNode, schema) {
            if (!(node instanceof Element)) {
              const paragraphType = schema.nodes['paragraph'];
              const textContent = node.textContent || '';
              const paragraph = textContent
                ? paragraphType.create(null, schema.text(textContent))
                : paragraphType.create(null);
              return Fragment.from(paragraph);
            }

            const contentElement = node.querySelector('.simple-callout-content') ?? node;

            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = contentElement.innerHTML;
            const parsedContent = DOMParser.fromSchema(schema).parse(tempDiv);

            return parsedContent.content;
          },
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: simpleCalloutClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(SimpleCalloutComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
